(function () {
  if (window.toaCartEnhancementsLoaded) return;
  window.toaCartEnhancementsLoaded = true;
  window.toaCartEnhancementsVersion = "20260726-mobile-checkout-above-products";

  var thresholdFallback = 4900;
  var countdownKey = "toaCartCountdownUntil";
  var countdownDuration = 30 * 60 * 1000;
  var updateTimer = null;
  var storefrontQuantitySyncTimer = null;
  var mutationTimer = null;
  var cartMutationQueue = Promise.resolve();
  var keepDrawerOpenUntil = 0;
  var cartCloseGuardUntil = 0;
  var userClosedDrawer = false;
  var pendingCartHighlightVariant = "";
  var pendingCartHighlightUntil = 0;
  var lastFreeShippingProgress = null;
  var lastFreeShippingPackageLeft = null;

  function injectStyle() {
    if (document.getElementById("toa-cart-enhancement-style")) return;
    var style = document.createElement("style");
    style.id = "toa-cart-enhancement-style";
    style.textContent = [
      "@media (min-width: 900px) {",
      "  .cart-summary { width: min(575px, 42vw) !important; max-width: calc(100vw - 24px) !important; right: calc(-1 * min(575px, 42vw)) !important; }",
      "  .cart-summary .cart-summary-item__image { width: 104px !important; }",
      "  .cart-summary .cart-summary-item__image img, .cart-summary .cart-summary-item__image .rimage__image { width: 104px !important; max-width: 104px !important; }",
      "}",
      ".cart-summary.toa-cart-drawer-upgraded { --toa-drawer-green: #123f2a; --toa-drawer-red: #e30613; --toa-drawer-cream: #fff7eb; --toa-drawer-border: #ead9bf; background: linear-gradient(180deg,#fffaf2 0%,#fff7eb 56%,#fffdf8 100%) !important; color: var(--toa-drawer-green) !important; overflow-y: auto !important; -webkit-overflow-scrolling: touch; scrollbar-gutter: stable; }",
      "body.toa-cart-close-guard .cart-summary, html.toa-cart-close-guard body .cart-summary { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; transform: translate3d(110%,0,0) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary__header { display: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary__close { display: none !important; }",
      ".toa-cart-drawer-topbar { position: relative !important; top: auto !important; z-index: 5 !important; display: flex; align-items: center; justify-content: space-between; gap: 14px; margin: 0 !important; padding: 14px 22px 10px; color: var(--toa-drawer-green); pointer-events: auto !important; background: #fffaf2; border-bottom: 1px solid rgba(18,63,42,.09); box-shadow: 0 8px 22px rgba(70,46,19,.05); isolation: isolate; }",
      ".toa-cart-drawer-back, .toa-cart-drawer-close { position: relative; z-index: 2147483647; appearance: none; border: 0; background: transparent; color: var(--toa-drawer-green); display: inline-flex; align-items: center; justify-content: center; cursor: pointer; pointer-events: auto !important; touch-action: manipulation; -webkit-tap-highlight-color: transparent; }",
      ".toa-cart-drawer-back > *, .toa-cart-drawer-close > * { pointer-events: none !important; }",
      ".toa-cart-drawer-back { gap: 10px; min-height: 52px; padding: 0 12px 0 0; font-size: 20px; font-weight: 750; letter-spacing: 0; }",
      ".toa-cart-drawer-close { width: 44px; height: 44px; padding: 0; border-radius: 999px; }",
      ".toa-cart-drawer-back svg, .toa-cart-drawer-close svg, .toa-cart-products-heading svg, .toa-cart-trust-line svg { width: 25px; height: 25px; stroke: currentColor; stroke-width: 2.25; fill: none; stroke-linecap: round; stroke-linejoin: round; }",
      ".toa-cart-drawer-close:hover, .toa-cart-drawer-close:focus-visible, .toa-cart-drawer-back:hover, .toa-cart-drawer-back:focus-visible { color: #0b2f20; outline: none; }",
      ".toa-cart-drawer-brand { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 11px; padding: 2px 20px 16px; text-align: center; color: var(--toa-drawer-green); }",
      ".toa-cart-drawer-brand img { width: clamp(112px, 26vw, 152px); height: clamp(112px, 26vw, 152px); border-radius: 999px; object-fit: contain; display: block; filter: drop-shadow(0 12px 22px rgba(18,63,42,.13)); }",
      ".toa-cart-drawer-brand span { font-size: clamp(16px, 2.6vw, 20px); line-height: 1.25; font-weight: 650; letter-spacing: 0; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-conversion-panel { flex: 0 0 auto; margin: 10px 16px 16px !important; border-radius: 18px !important; box-shadow: 0 14px 30px rgba(70,46,19,.10) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-conversion-panel--drawer-top { order: -1; }",
      ".toa-cart-products-heading { width: calc(100% - 32px); margin: 18px 16px 12px; padding: 0; min-height: 52px; border: 0; background: transparent; color: #102f22; display: flex; align-items: center; justify-content: space-between; gap: 14px; cursor: pointer; font-size: clamp(18px, 2.7vw, 22px); font-weight: 760; text-align: left; }",
      ".toa-cart-products-heading svg { width: 24px; height: 24px; transition: transform .18s ease; }",
      ".cart-summary.toa-products-collapsed .toa-cart-products-heading svg { transform: rotate(180deg); }",
      ".cart-summary.toa-products-collapsed .toa-cart-products-list { display: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-list { display: grid !important; gap: 14px !important; padding: 0 16px 18px !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item-container, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item { background: rgba(255,255,255,.92) !important; border: 1px solid rgba(234,217,191,.95) !important; border-radius: 22px !important; box-shadow: 0 14px 34px rgba(70,46,19,.08) !important; padding: 16px !important; color: #122f23 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image { width: clamp(92px, 24vw, 120px) !important; min-width: clamp(92px, 24vw, 120px) !important; align-self: center !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image img, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image .rimage__image { width: 100% !important; max-width: 120px !important; height: auto !important; object-fit: contain !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__title, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item a[href*='/products'] { color: #122f23 !important; font-size: clamp(16px, 2.7vw, 20px) !important; line-height: 1.23 !important; font-weight: 750 !important; text-decoration: none !important; letter-spacing: 0 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__price, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item .amount, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__final-price { color: #122f23 !important; font-size: clamp(17px, 2.7vw, 20px) !important; font-weight: 850 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button { width: 44px !important; height: 44px !important; min-width: 44px !important; border-radius: 999px !important; border: 1px solid rgba(227,6,19,.28) !important; background: rgba(255,250,250,.95) !important; color: var(--toa-drawer-red) !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; padding: 0 !important; text-decoration: none !important; box-shadow: 0 8px 18px rgba(227,6,19,.08) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button svg { width: 20px; height: 20px; stroke: currentColor; stroke-width: 2.15; fill: none; stroke-linecap: round; stroke-linejoin: round; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button:hover, .cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button:focus-visible { background: rgba(227,6,19,.08) !important; border-color: rgba(227,6,19,.48) !important; outline: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster, .cart-summary.toa-cart-drawer-upgraded .quantity, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity { min-height: 46px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; border: 1px solid rgba(234,217,191,.95) !important; border-radius: 999px !important; background: #fffdf8 !important; overflow: hidden !important; box-shadow: inset 0 1px 0 rgba(255,255,255,.9) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill button, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster button, .cart-summary.toa-cart-drawer-upgraded .quantity button, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity button { width: 46px !important; height: 46px !important; border: 0 !important; background: #f2f5ed !important; color: var(--toa-drawer-green) !important; font-size: 24px !important; font-weight: 800 !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill input, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster input, .cart-summary.toa-cart-drawer-upgraded .quantity input, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity input { min-width: 54px !important; height: 46px !important; border: 0 !important; background: transparent !important; color: #102f22 !important; font-size: 18px !important; font-weight: 750 !important; text-align: center !important; box-shadow: none !important; }",
      ".toa-native-products-heading, .cart-summary.toa-cart-drawer-upgraded .toa-native-products-heading, .cart-summary.toa-cart-drawer-upgraded .toa-native-products-heading * { display: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-heading { margin: 22px 18px 16px !important; min-height: 58px !important; font-size: clamp(24px, 5vw, 34px) !important; font-weight: 950 !important; letter-spacing: 0 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-heading svg { width: 31px !important; height: 31px !important; stroke-width: 2.55 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-list { gap: 18px !important; padding: 0 18px 20px !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item-container { background: linear-gradient(135deg,#fffefa 0%,#fff8ed 100%) !important; border: 1px solid rgba(234,217,191,.98) !important; border-radius: 26px !important; box-shadow: 0 18px 44px rgba(70,46,19,.11), inset 0 1px 0 rgba(255,255,255,.92) !important; padding: 18px !important; color: #102f22 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item-container > .cart-summary-item { background: transparent !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; padding: 0 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-list > .cart-summary-item { background: linear-gradient(135deg,#fffefa 0%,#fff8ed 100%) !important; border: 1px solid rgba(234,217,191,.98) !important; border-radius: 26px !important; box-shadow: 0 18px 44px rgba(70,46,19,.11), inset 0 1px 0 rgba(255,255,255,.92) !important; padding: 18px !important; color: #102f22 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item { display: grid !important; grid-template-columns: minmax(104px,132px) minmax(0,1fr) auto !important; gap: 18px !important; align-items: center !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image { width: clamp(104px, 25vw, 132px) !important; min-width: clamp(104px, 25vw, 132px) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image img, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image .rimage__image { max-width: 132px !important; max-height: 132px !important; object-fit: contain !important; filter: drop-shadow(0 12px 16px rgba(18,63,42,.1)); }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__title, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item a[href*='/products'] { font-size: clamp(18px,3.4vw,25px) !important; line-height: 1.16 !important; font-weight: 900 !important; color: #102f22 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__price, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item .amount, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__final-price { font-size: clamp(24px,5vw,34px) !important; line-height: 1 !important; font-weight: 950 !important; color: #242424 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item [class*='unit'], .cart-summary.toa-cart-drawer-upgraded .cart-summary-item [class*='base'], .cart-summary.toa-cart-drawer-upgraded .cart-summary-item small { color: rgba(18,47,35,.66) !important; font-size: clamp(14px,2.8vw,18px) !important; font-weight: 520 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button { width: 52px !important; height: 52px !important; min-width: 52px !important; border: 2px solid rgba(227,6,19,.36) !important; background: radial-gradient(circle at 50% 35%,#fff 0%,#fff8f3 100%) !important; box-shadow: 0 12px 24px rgba(227,6,19,.12) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button svg { width: 25px !important; height: 25px !important; stroke-width: 2.45 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster, .cart-summary.toa-cart-drawer-upgraded .quantity, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity { min-width: 172px !important; min-height: 54px !important; border: 2px solid rgba(234,217,191,1) !important; background: linear-gradient(180deg,#fffefa,#fff8ee) !important; box-shadow: 0 10px 20px rgba(70,46,19,.08), inset 0 1px 0 rgba(255,255,255,.95) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill button, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster button, .cart-summary.toa-cart-drawer-upgraded .quantity button, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity button { width: 56px !important; height: 54px !important; background: rgba(242,245,237,.96) !important; font-size: 28px !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill input, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster input, .cart-summary.toa-cart-drawer-upgraded .quantity input, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity input { height: 54px !important; min-width: 60px !important; font-size: 23px !important; }",
      "@media (max-width: 749px) { .cart-summary.toa-cart-drawer-upgraded .cart-summary-item { grid-template-columns: 112px minmax(0,1fr) !important; gap: 14px !important; } .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image { width: 112px !important; min-width: 112px !important; } .cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button { width: 48px !important; height: 48px !important; min-width: 48px !important; justify-self: end !important; } .cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster, .cart-summary.toa-cart-drawer-upgraded .quantity, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity { min-width: 156px !important; } }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button), .cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill:has(.toa-cart-remove-button) { min-width: 0 !important; width: auto !important; border: 0 !important; border-radius: 0 !important; background: transparent !important; box-shadow: none !important; overflow: visible !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .qty-adjuster__down { border: 0 !important; border-radius: 0 !important; background: #f2f5ed !important; box-shadow: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .qty-adjuster__value { border: 0 !important; background: #fff !important; box-shadow: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .qty-adjuster__up { border: 0 !important; border-radius: 0 !important; background: #fff !important; box-shadow: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .toa-cart-remove-button { margin-left: 12px !important; width: 52px !important; height: 52px !important; min-width: 52px !important; border-radius: 12px !important; border: 2px solid rgba(227,6,19,.32) !important; background: #fffaf7 !important; color: var(--toa-drawer-red) !important; box-shadow: none !important; }",
      "@media (max-width: 749px) { .cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button), .cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill:has(.toa-cart-remove-button) { min-width: 0 !important; } .cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .toa-cart-remove-button { width: 48px !important; height: 48px !important; min-width: 48px !important; margin-left: 10px !important; } }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary__button-row, .cart-summary.toa-cart-drawer-upgraded .cart-summary__buttons { position: relative !important; bottom: auto !important; z-index: 10 !important; padding: 0 !important; background: transparent !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-checkout-block { flex: 0 0 auto !important; order: 0 !important; margin: 0 16px 14px !important; padding: 12px !important; border: 1px solid rgba(234,217,191,.95) !important; border-radius: 18px !important; background: rgba(255,250,242,.96) !important; box-shadow: 0 12px 28px rgba(70,46,19,.08) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-checkout-block .cart-summary__button-row, .cart-summary.toa-cart-drawer-upgraded .toa-cart-checkout-block .cart-summary__buttons { margin: 0 !important; }",
      ".toa-cart-estimated-shipping { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 0 0 10px; color: #315c3b; font-size: 14px; line-height: 1.2; font-weight: 750; }",
      ".toa-cart-estimated-shipping strong { color: #102f22; font-size: 15px; font-weight: 950; white-space: nowrap; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-checkout-totalized { width: 100% !important; min-height: 58px !important; border-radius: 13px !important; background: linear-gradient(135deg,#123f2a,#225f35) !important; color: #fff !important; border: 0 !important; box-shadow: 0 13px 26px rgba(18,63,42,.22) !important; font-size: clamp(18px, 3vw, 22px) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-checkout-totalized::before { content: ''; width: 22px; height: 22px; flex: 0 0 22px; background: currentColor; opacity: .92; -webkit-mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='11' width='18' height='11' rx='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'/%3E%3C/svg%3E\") center/contain no-repeat; mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='11' width='18' height='11' rx='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'/%3E%3C/svg%3E\") center/contain no-repeat; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-checkout-totalized::after { content: '\\2192'; margin-left: auto; padding-right: 4px; font-size: 28px; font-weight: 500; }",
      ".cart-summary.toa-cart-is-empty .toa-checkout-totalized, .cart-summary.toa-cart-is-empty [data-toa-cart-trust-line], .cart-summary [data-toa-empty-checkout-hidden='true'], #cartform [data-toa-empty-checkout-hidden='true'] { display: none !important; }",
      ".toa-cart-trust-line { display: flex; align-items: center; justify-content: center; gap: 8px; padding: 0 16px 16px; color: #315c3b; font-size: 14px; font-weight: 650; }",
      ".toa-cart-trust-line svg { width: 21px; height: 21px; }",
      "@media (max-width: 749px) { .cart-summary.toa-cart-drawer-upgraded { width: min(94vw, 560px) !important; max-width: calc(100vw - 10px) !important; border-radius: 28px 0 0 28px !important; } .toa-cart-drawer-topbar { min-height: 68px; padding: max(10px, env(safe-area-inset-top)) 14px 8px 18px !important; } .toa-cart-drawer-back { min-width: 210px; min-height: 56px; font-size: 19px; justify-content: flex-start; } .toa-cart-drawer-close { width: 54px; height: 54px; margin-right: -4px; } .cart-summary.toa-cart-drawer-upgraded .toa-cart-conversion-panel { margin: 8px 12px 12px !important; border-radius: 18px !important; } .cart-summary.toa-cart-drawer-upgraded .toa-cart-checkout-block { margin: 0 12px 12px !important; } }",
      "body.show-cart-summary .cart-summary, html.show-cart-summary body .cart-summary, body.product-added-to-cart .cart-summary.active { display: block !important; position: fixed !important; top: 0 !important; left: auto !important; right: 0 !important; bottom: 0 !important; height: 100vh !important; transform: translate3d(0,0,0) !important; opacity: 1 !important; visibility: visible !important; pointer-events: auto !important; z-index: 2147483646 !important; }",
      "body.show-cart-summary #page-overlay, body.show-cart-summary .page-overlay { z-index: 2147483640 !important; }",
      ".toa-cart-limit-toast { position: fixed; top: 88px; right: 24px; z-index: 999999; max-width: min(360px, calc(100vw - 32px)); padding: 13px 16px; border-radius: 10px; background: #fff4e0; color: #173b28; border: 1px solid #f1b45d; box-shadow: 0 14px 36px rgba(23,59,40,0.18); font-weight: 800; line-height: 1.28; opacity: 0; transform: translateY(-8px); pointer-events: none; transition: opacity .18s ease, transform .18s ease; }",
      ".toa-cart-limit-toast.is-visible { opacity: 1; transform: translateY(0); }",
      ".cart-summary.toa-cart-limit-flash { animation: toaCartLimitFlash .9s ease; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse, .cart-summary .cart-summary-item.toa-cart-item-pulse { position: relative; overflow: hidden; isolation: isolate; animation: toaCartItemPulse 1.9s cubic-bezier(.18,.82,.22,1) both; border-radius: 16px; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse::before, .cart-summary .cart-summary-item.toa-cart-item-pulse::before { content: ''; position: absolute; inset: 4px; z-index: 0; pointer-events: none; border-radius: 14px; background: radial-gradient(circle at 16% 18%, rgba(255,255,255,.86), rgba(255,255,255,0) 34%), linear-gradient(105deg, rgba(255,250,238,.95), rgba(245,252,240,.98) 52%, rgba(255,244,210,.93)); box-shadow: inset 0 0 0 1px rgba(204,165,70,.42); opacity: 0; animation: toaCartItemWash 1.85s ease both; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse::after, .cart-summary .cart-summary-item.toa-cart-item-pulse::after { content: ''; position: absolute; top: 0; bottom: 0; left: -42%; width: 42%; z-index: 1; pointer-events: none; background: linear-gradient(105deg, rgba(255,255,255,0), rgba(255,255,255,.68), rgba(255,225,150,.34), rgba(255,255,255,0)); filter: blur(.3px); transform: skewX(-12deg) translateX(-115%); animation: toaCartItemSweep 1.22s ease .16s both; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse > *, .cart-summary .cart-summary-item.toa-cart-item-pulse > * { position: relative; z-index: 2; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse .cart-summary-item__image, .cart-summary .cart-summary-item.toa-cart-item-pulse .cart-summary-item__image { animation: toaCartImagePop 1.15s cubic-bezier(.18,.82,.22,1) both; }",
      ".toa-cart-confirm-badge { position: absolute; top: 10px; right: 12px; z-index: 4; display: inline-flex; align-items: center; gap: 6px; padding: 6px 10px; border-radius: 999px; background: linear-gradient(135deg,#173b28,#285f3b); color: #fff; border: 1px solid rgba(226,184,79,.7); box-shadow: 0 10px 22px rgba(23,59,40,.22); font-size: 12px; font-weight: 900; letter-spacing: 0; white-space: nowrap; pointer-events: none; animation: toaCartBadgeIn 1.9s ease both; }",
      ".toa-cart-confirm-badge::before { content: '+'; width: 18px; height: 18px; border-radius: 999px; display: inline-flex; align-items: center; justify-content: center; background: #f4c95d; color: #173b28; font-weight: 1000; box-shadow: inset 0 -1px 0 rgba(0,0,0,.12); }",
      ".cart-summary .cart-summary__subtotal > .cart-summary__subtotal-label, .cart-summary .cart-summary__subtotal > .amount { display: none !important; }",
      ".cart-summary .cart-summary__subtotal:not(:has(.cart-discount-list)) { display: none !important; }",
      ".cart-subtotal { display: none !important; }",
      ".toa-checkout-totalized { display: inline-flex !important; align-items: center !important; justify-content: center !important; gap: 8px !important; white-space: nowrap !important; }",
      ".toa-checkout-totalized .toa-checkout-button-label { font-weight: 900; }",
      ".toa-checkout-totalized .toa-checkout-button-separator { opacity: .72; font-weight: 900; }",
      ".toa-checkout-totalized .toa-checkout-button-total { font-weight: 1000; }",
      "@media (max-width: 520px) { .toa-cart-confirm-badge { top: 8px; right: 8px; font-size: 11px; padding: 5px 8px; } }",
      "@media (max-width: 520px) { .toa-checkout-totalized { gap: 6px !important; } }",
      "@keyframes toaCartLimitFlash { 0%,100% { box-shadow: none; } 20%,70% { box-shadow: 0 0 0 4px rgba(218,42,42,.18), 0 0 0 9999px rgba(23,59,40,.05); } }",
      "@keyframes toaCartItemPulse { 0% { box-shadow: none; transform: translateX(0) scale(1); } 16% { box-shadow: 0 18px 42px rgba(23,59,40,.17), 0 0 0 1px rgba(212,169,70,.48); transform: translateX(-2px) scale(1.012); } 58% { box-shadow: 0 12px 26px rgba(23,59,40,.10), 0 0 0 1px rgba(31,112,68,.18); transform: translateX(0) scale(1); } 100% { box-shadow: none; transform: translateX(0) scale(1); } }",
      "@keyframes toaCartItemWash { 0% { opacity: 0; transform: scale(.985); } 12% { opacity: 1; transform: scale(1); } 72% { opacity: .94; } 100% { opacity: 0; transform: scale(1.006); } }",
      "@keyframes toaCartItemSweep { 0% { transform: skewX(-12deg) translateX(-115%); opacity: 0; } 18% { opacity: 1; } 100% { transform: skewX(-12deg) translateX(360%); opacity: 0; } }",
      "@keyframes toaCartImagePop { 0% { transform: scale(.96); filter: saturate(1); } 22% { transform: scale(1.055); filter: saturate(1.08) drop-shadow(0 8px 12px rgba(23,59,40,.16)); } 100% { transform: scale(1); filter: saturate(1); } }",
      "@keyframes toaCartBadgeIn { 0% { opacity: 0; transform: translateY(-6px) scale(.92); } 12%,64% { opacity: 1; transform: translateY(0) scale(1); } 100% { opacity: 0; transform: translateY(-3px) scale(.97); } }"
    ].join("\n");
    document.head.appendChild(style);
  }

  function getCountdownEnd() {
    var end = 0;
    try {
      end = Number(window.localStorage && window.localStorage.getItem(countdownKey));
    } catch (error) {}
    if (!end) {
      end = Date.now() + countdownDuration;
      try {
        window.localStorage.setItem(countdownKey, String(end));
      } catch (error) {}
    }
    return end;
  }

  function restartCountdown() {
    try {
      window.localStorage.setItem(countdownKey, String(Date.now() + countdownDuration));
    } catch (error) {}
    renderCountdown();
  }

  function renderCountdown() {
    var lines = document.querySelectorAll("[data-toa-cart-countdown-line]");
    var nodes = document.querySelectorAll("[data-toa-cart-countdown]");
    if (!nodes.length && !lines.length) return;
    var rawLeft = getCountdownEnd() - Date.now();
    var left = Math.max(0, rawLeft);
    var expired = rawLeft <= 0;
    var minutes = Math.floor(left / 60000);
    var seconds = Math.floor((left % 60000) / 1000);
    var text = String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0") + " Minuten";
    lines.forEach(function (line) {
      if (expired) {
        line.textContent = "Dein Warenkorb ist weiterhin für dich bereit.";
        return;
      }
      if (!line.querySelector("[data-toa-cart-countdown]")) {
        line.innerHTML = "Dein Warenkorb liegt noch <strong data-toa-cart-countdown></strong> für dich bereit.";
      }
      var node = line.querySelector("[data-toa-cart-countdown]");
      if (node) node.textContent = text;
    });
    if (!lines.length) {
      nodes.forEach(function (node) {
        node.textContent = expired ? "weiterhin verfügbar" : text;
      });
    }
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace(".", ",") + " €";
    }
  }

  function setCheckoutButtonTotal(button, totalText) {
    if (!button) return;
    var fullLabel = "Zur Kasse \u2013 " + totalText;
    if (button.tagName === "INPUT") {
      button.value = fullLabel;
      button.setAttribute("aria-label", fullLabel);
      return;
    }
    if (button.getAttribute("data-toa-checkout-total") === totalText) return;
    button.setAttribute("data-toa-checkout-total", totalText);
    button.setAttribute("aria-label", fullLabel);
    button.classList.add("toa-checkout-totalized");
    button.textContent = "";
    var label = document.createElement("span");
    label.className = "toa-checkout-button-label";
    label.textContent = "Zur Kasse";
    var separator = document.createElement("span");
    separator.className = "toa-checkout-button-separator";
    separator.textContent = "\u2013";
    var total = document.createElement("span");
    total.className = "toa-checkout-button-total";
    total.textContent = totalText;
    button.appendChild(label);
    button.appendChild(separator);
    button.appendChild(total);
  }

  function isPfandCartItem(item) {
    if (!item) return false;
    var text = [
      item.title,
      item.product_title,
      item.variant_title,
      item.product_type,
      item.handle,
      item.url
    ].join(" ").toLowerCase();
    var properties = item.properties || {};
    var productType = String(item.product_type || "").toLowerCase();
    var propertyText = "";
    try {
      propertyText = JSON.stringify(properties).toLowerCase();
    } catch (error) {
      propertyText = "";
    }
    return !!(
      properties._toa_pfand_auto ||
      propertyText.indexOf("_toa_pfand_auto") !== -1 ||
      text.indexOf("pfand-fuer-flaschen-dosen") !== -1 ||
      text.indexOf("0-25-pfand") !== -1 ||
      productType === "pfand" ||
      (text.indexOf("pfand") !== -1 && (text.indexOf("flaschen") !== -1 || text.indexOf("dosen") !== -1))
    );
  }

  function cartLinePrice(item) {
    if (!item) return 0;
    return Number(item.final_line_price || item.line_price || item.original_line_price || 0) || 0;
  }

  function cartPfandTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (total, item) {
      if (!isPfandCartItem(item)) return total;
      return total + cartLinePrice(item);
    }, 0);
  }

  function cartNonPfandTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (total, item) {
      if (isPfandCartItem(item)) return total;
      return total + cartLinePrice(item);
    }, 0);
  }

  function cartFreeShippingBasis(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return Math.max(0, cartNonPfandTotal(cart));
  }

  function cartHasOnlyPfand(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    var activeItems = cart.items.filter(function (item) {
      return Number(item && item.quantity || 0) > 0;
    });
    return activeItems.length > 0 && activeItems.every(isPfandCartItem);
  }

  function cartForCustomerDisplay(cart) {
    if (!cartHasOnlyPfand(cart)) return cart;
    return Object.assign({}, cart, {
      items: [],
      item_count: 0,
      total_price: 0
    });
  }

  function cartIsEmpty(cart) {
    if (cart && Array.isArray(cart.items)) {
      if (cartHasOnlyPfand(cart)) return true;
      return !cart.items.some(function (item) {
        return Number(item && item.quantity) > 0;
      });
    }
    if (cart && typeof cart.item_count === "number") return cart.item_count <= 0;
    var drawer = getCartDrawer();
    if (!drawer) return false;
    return !drawer.querySelector(".cart-summary-item, .cart-summary-item-container, .ajaxcart__product");
  }

  function setEmptyHidden(node, hidden) {
    if (!node) return;
    if (hidden) {
      if (node.style && node.getAttribute("data-toa-empty-checkout-hidden") !== "true") {
        node.setAttribute("data-toa-empty-prev-display", node.style.getPropertyValue("display") || "");
        node.setAttribute("data-toa-empty-prev-display-priority", node.style.getPropertyPriority("display") || "");
      }
      if (node.style) node.style.setProperty("display", "none", "important");
      node.setAttribute("data-toa-empty-checkout-hidden", "true");
      node.setAttribute("aria-hidden", "true");
      if (node.matches && node.matches("button, input")) {
        if (!node.disabled) node.setAttribute("data-toa-empty-disabled-by-script", "true");
        node.disabled = true;
      }
      return;
    }
    if (node.getAttribute("data-toa-empty-checkout-hidden") === "true") {
      node.removeAttribute("data-toa-empty-checkout-hidden");
      node.removeAttribute("aria-hidden");
      if (node.style && node.hasAttribute("data-toa-empty-prev-display")) {
        var previousDisplay = node.getAttribute("data-toa-empty-prev-display") || "";
        var previousPriority = node.getAttribute("data-toa-empty-prev-display-priority") || "";
        if (previousDisplay) node.style.setProperty("display", previousDisplay, previousPriority);
        else node.style.removeProperty("display");
      }
      node.removeAttribute("data-toa-empty-prev-display");
      node.removeAttribute("data-toa-empty-prev-display-priority");
    }
    if (node.getAttribute("data-toa-empty-disabled-by-script") === "true") {
      node.disabled = false;
      node.removeAttribute("data-toa-empty-disabled-by-script");
    }
  }

  function setEmptyCartCheckoutState(cart) {
    var empty = cartIsEmpty(cart);
    var drawer = getCartDrawer();
    if (drawer) drawer.classList.toggle("toa-cart-is-empty", empty);
    var scopes = [];
    if (drawer) scopes.push(drawer);
    var cartForm = document.getElementById("cartform");
    if (cartForm) scopes.push(cartForm);
    var controlSelector = [
      "button[name='checkout']",
      "input[name='checkout']",
      "a[href*='/checkout']"
    ].join(",");
    var seenContainers = [];
    scopes.forEach(function (scope) {
      scope.querySelectorAll(controlSelector).forEach(function (control) {
        setEmptyHidden(control, empty);
        var container = control.closest(".cart-summary__button-row, .cart-summary__buttons");
        if (container && seenContainers.indexOf(container) === -1) {
          seenContainers.push(container);
          setEmptyHidden(container, empty);
        }
      });
      scope.querySelectorAll("[data-toa-cart-trust-line]").forEach(function (trust) {
        setEmptyHidden(trust, empty);
      });
    });
    document.querySelectorAll("[data-toa-cart-panel]").forEach(function (panel) {
      if (panel.closest(".toa-pfand-cart-line, [data-toa-pfand-line], [data-toa-pfand-fallback]")) return;
      setEmptyHidden(panel, empty);
    });
  }

  function updateCheckoutButtons(cart) {
    if (!cart || typeof cart.total_price !== "number") return;
    if (cartIsEmpty(cart)) {
      setEmptyCartCheckoutState(cart);
      return;
    }
    var totalText = formatMoney(cart.total_price);
    var selector = [
      ".cart-summary button[name='checkout']",
      ".cart-summary input[name='checkout']",
      ".cart-summary a[href*='/checkout']",
      "#cartform button[name='checkout']",
      "#cartform input[name='checkout']",
      "#cartform a[href*='/checkout']",
      "form[action*='/cart'] button[name='checkout']",
      "form[action*='/cart'] input[name='checkout']",
      "button[name='checkout']",
      "input[name='checkout']",
      "a[href*='/checkout']"
    ].join(",");
    var seen = [];
    document.querySelectorAll(selector).forEach(function (button) {
      if (seen.indexOf(button) !== -1) return;
      seen.push(button);
      setCheckoutButtonTotal(button, totalText);
    });
    setEmptyCartCheckoutState(cart);
  }

  function toaCartIcon(name) {
    var paths = {
      back: "<path d='M15 18l-6-6 6-6'/>",
      close: "<path d='M18 6 6 18'/><path d='m6 6 12 12'/>",
      chevron: "<path d='m6 15 6-6 6 6'/>",
      trash: "<path d='M3 6h18'/><path d='M8 6V4h8v2'/><path d='M19 6l-1 14H6L5 6'/><path d='M10 11v5'/><path d='M14 11v5'/>",
      shield: "<path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'/><path d='m9 12 2 2 4-5'/>"
    };
    return "<svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'>" + (paths[name] || "") + "</svg>";
  }

  function getCartDrawer() {
    return document.querySelector(".cart-summary");
  }

  function closeCartDrawerFromControl(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
    }
    allowCartDrawerClose();
  }

  function inlineCartDrawerClose(event) {
    closeCartDrawerFromControl(event);
    return false;
  }

  window.toaCartDrawerInlineClose = inlineCartDrawerClose;

  function attachDrawerCloseControl(control) {
    if (!control || control.getAttribute("data-toa-drawer-close-ready") === "true") return;
    control.setAttribute("data-toa-drawer-close", "true");
    control.setAttribute("data-toa-drawer-close-ready", "true");
    ["pointerdown", "mousedown", "touchstart", "click"].forEach(function (type) {
      try {
        control.addEventListener(type, closeCartDrawerFromControl, { capture: true, passive: false });
      } catch (error) {
        control.addEventListener(type, closeCartDrawerFromControl, true);
      }
    });
  }

  function isDrawerContinueControl(node) {
    if (!node || !node.closest) return false;
    var drawer = node.closest(".cart-summary");
    if (!drawer) return false;
    var control = node.closest("button, a, [role='button'], [data-toa-drawer-close]");
    if (!control || !drawer.contains(control)) return false;
    if (control.hasAttribute("data-toa-drawer-close")) return true;
    var text = (control.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
    return text === "weitershoppen" ||
      text === "weiter shoppen" ||
      text === "weiter einkaufen" ||
      text.indexOf("weitershoppen") !== -1 ||
      text.indexOf("weiter shoppen") !== -1 ||
      text.indexOf("weiter einkaufen") !== -1;
  }

  function ensureDrawerTopbar(drawer) {
    if (!drawer || drawer.querySelector("[data-toa-drawer-topbar]")) return;
    var topbar = document.createElement("div");
    topbar.className = "toa-cart-drawer-topbar";
    topbar.setAttribute("data-toa-drawer-topbar", "true");
    var continueHref = String((window.location.pathname || "/") + (window.location.search || "") + (window.location.hash || "")).replace(/'/g, "%27");
    var inlineCloseAttrs = " onpointerdown='return window.toaCartDrawerInlineClose ? window.toaCartDrawerInlineClose(event) : false' onclick='return window.toaCartDrawerInlineClose ? window.toaCartDrawerInlineClose(event) : false'";
    topbar.innerHTML =
      "<button class='toa-cart-drawer-back' type='button' data-toa-continue-href='" + continueHref + "' data-toa-drawer-close" + inlineCloseAttrs + ">" +
        toaCartIcon("back") +
        "<span>Weiter einkaufen</span>" +
      "</button>" +
      "<button class='toa-cart-drawer-close' type='button' aria-label='Warenkorb schliessen' data-toa-drawer-close" + inlineCloseAttrs + ">" +
        toaCartIcon("close") +
      "</button>";
    drawer.insertBefore(topbar, drawer.firstChild);
    attachDrawerCloseControl(topbar);
    topbar.querySelectorAll("[data-toa-drawer-close]").forEach(function (button) {
      attachDrawerCloseControl(button);
    });
  }

  function enhanceDrawerCloseControls(drawer) {
    if (!drawer) return;
    var selector = [
      ".cart-summary__close",
      ".cart-close",
      ".drawer__close",
      ".js-close-cart",
      "[data-cart-close]",
      "[data-toa-drawer-close]"
    ].join(",");
    drawer.querySelectorAll(selector).forEach(function (control) {
      attachDrawerCloseControl(control);
    });
    drawer.querySelectorAll("button, a, [role='button']").forEach(function (control) {
      if (isDrawerContinueControl(control)) attachDrawerCloseControl(control);
    });
  }

  function closeDrawerIfControlEvent(event) {
    var target = event && event.target;
    if (!target || !target.closest) return false;
    var drawer = target.closest(".cart-summary");
    if (!drawer) return false;
    var closeTarget = target.closest("[data-toa-drawer-close], .cart-summary__close, .cart-close, .drawer__close, .js-close-cart, [data-cart-close]");
    if (closeTarget && drawer.contains(closeTarget)) {
      closeCartDrawerFromControl(event);
      return true;
    }
    if (isDrawerContinueControl(target)) {
      closeCartDrawerFromControl(event);
      return true;
    }
    return false;
  }

  function ensureDrawerBrandFallback(drawer) {
    if (!drawer || drawer.querySelector("[data-toa-drawer-brand]")) return;
    if (drawer.querySelector(".toa-cart-conversion-panel__brand")) return;
    var logo = document.querySelector(".site-header__logo img, .header-logo img, img[alt='Taste of Asia']");
    if (!logo || !logo.getAttribute("src")) return;
    var brand = document.createElement("div");
    brand.className = "toa-cart-drawer-brand";
    brand.setAttribute("data-toa-drawer-brand", "true");
    brand.innerHTML =
      "<img src='" + logo.getAttribute("src") + "' alt='Taste of Asia'>" +
      "<span>Asiatische Lebensmittel online &amp; im Laden</span>";
    var anchor = drawer.querySelector("[data-toa-cart-panel]") || drawer.firstChild;
    drawer.insertBefore(brand, anchor);
  }

  function getCartItemNodes(drawer) {
    if (!drawer) return [];
    var selectors = [
      ".cart-summary-item-container",
      ".cart-summary-item",
      "[data-cart-item]",
      ".ajaxcart__product"
    ].join(",");
    var nodes = Array.prototype.slice.call(drawer.querySelectorAll(selectors));
    return nodes.filter(function (node) {
      return !node.closest("[data-toa-cart-panel]") && !node.closest("[data-toa-products-heading]");
    });
  }

  function normalizeCartText(text) {
    return (text || "").replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
  }

  function isNativeProductsHeading(node, ownHeading) {
    if (!node || node === ownHeading) return false;
    if (node.closest("[data-toa-products-heading]")) return false;
    if (node.hasAttribute("data-toa-products-heading") || node.classList.contains("toa-cart-products-heading")) return false;
    if (ownHeading && (node.contains(ownHeading) || ownHeading.contains(node))) return false;
    if (node.closest("[data-toa-cart-panel]")) return false;
    var text = normalizeCartText(node.textContent);
    if (!text || /deine\s+produkte/i.test(text)) return false;
    return /^produkte(?:\s*\(\s*\d+\s*\))?$/i.test(text);
  }

  function markNativeProductsHeading(node) {
    node.classList.add("toa-native-products-heading");
    node.setAttribute("aria-hidden", "true");
    node.setAttribute("tabindex", "-1");
    var parent = node.parentElement;
    if (!parent || parent.classList.contains("toa-cart-products-list")) return;
    if (parent.closest("[data-toa-products-heading]") || parent.closest("[data-toa-cart-panel]")) return;
    var parentText = normalizeCartText(parent.textContent);
    var nodeText = normalizeCartText(node.textContent);
    if (parentText === nodeText && parent.children.length <= 3) {
      parent.classList.add("toa-native-products-heading");
      parent.setAttribute("aria-hidden", "true");
      parent.setAttribute("tabindex", "-1");
    }
  }

  function hideNativeProductHeadings(drawer, ownHeading) {
    if (!drawer) return;
    var candidates = Array.prototype.slice.call(drawer.querySelectorAll(
      "button, summary, h1, h2, h3, h4, h5, h6, [role='button'], [class*='heading'], [class*='title'], [class*='accordion'], [class*='toggle']"
    ));
    Array.prototype.slice.call(drawer.children || []).forEach(function (node) {
      if (candidates.indexOf(node) === -1) candidates.push(node);
    });
    candidates.forEach(function (node) {
      if (isNativeProductsHeading(node, ownHeading)) markNativeProductsHeading(node);
    });
  }

  function ensureProductHeading(drawer, cart) {
    var items = getCartItemNodes(drawer);
    var firstItem = items[0];
    if (!firstItem) return;
    var list = firstItem.parentElement;
    if (!list) return;
    list.classList.add("toa-cart-products-list");
    var heading = drawer.querySelector("[data-toa-products-heading]");
    if (!heading) {
      heading = document.createElement("button");
      heading.type = "button";
      heading.className = "toa-cart-products-heading";
      heading.setAttribute("data-toa-products-heading", "true");
      heading.setAttribute("aria-expanded", "true");
      heading.innerHTML =
        "<span>Deine Produkte (<span data-toa-products-count>0</span>)</span>" +
        toaCartIcon("chevron");
      list.parentElement.insertBefore(heading, list);
      heading.addEventListener("click", function () {
        var collapsed = !drawer.classList.contains("toa-products-collapsed");
        drawer.classList.toggle("toa-products-collapsed", collapsed);
        heading.setAttribute("aria-expanded", collapsed ? "false" : "true");
      });
    }
    var count = heading.querySelector("[data-toa-products-count]");
    if (count) count.textContent = cart && typeof cart.item_count === "number" ? String(cart.item_count) : String(items.length);
    hideNativeProductHeadings(drawer, heading);
  }

  function getCheckoutBlock(drawer) {
    if (!drawer) return null;
    var checkout = drawer.querySelector("button[name='checkout'], input[name='checkout'], a[href*='/checkout']");
    if (!checkout) return null;
    return checkout.closest(".cart-form--checkout") ||
      checkout.closest(".cart-summary__button-row, .cart-summary__buttons") ||
      checkout;
  }

  function ensureDrawerShippingPanelPosition(drawer) {
    if (!drawer) return;
    var panel = drawer.querySelector("[data-toa-cart-panel]");
    if (!panel) return;
    var heading = drawer.querySelector("[data-toa-products-heading]");
    var checkoutBlock = getCheckoutBlock(drawer);
    var anchor = checkoutBlock || heading || drawer.firstElementChild;
    if (anchor && anchor.parentElement && anchor !== panel && anchor.previousElementSibling !== panel) {
      anchor.parentElement.insertBefore(panel, anchor);
    }
    panel.classList.add("toa-cart-conversion-panel--drawer-top");
    panel.setAttribute("data-toa-drawer-panel-position", "top");
  }

  function ensureDrawerCheckoutPosition(drawer) {
    if (!drawer) return;
    var checkoutBlock = getCheckoutBlock(drawer);
    if (!checkoutBlock || checkoutBlock.closest("[data-toa-cart-panel]")) return;
    checkoutBlock.classList.add("toa-cart-checkout-block");
    checkoutBlock.setAttribute("data-toa-checkout-block", "true");
    var panel = drawer.querySelector("[data-toa-cart-panel]");
    var heading = drawer.querySelector("[data-toa-products-heading]");
    if (panel && panel.parentElement && panel.nextElementSibling !== checkoutBlock) {
      panel.parentElement.insertBefore(checkoutBlock, panel.nextSibling);
    }
    if (heading && heading.parentElement && heading.previousElementSibling !== checkoutBlock) {
      heading.parentElement.insertBefore(checkoutBlock, heading);
    }
  }

  function ensureEstimatedShippingLine(drawer, cart) {
    if (!drawer || !cart || cartIsEmpty(cart)) return;
    var checkoutBlock = getCheckoutBlock(drawer);
    if (!checkoutBlock) return;
    var line = checkoutBlock.querySelector("[data-toa-estimated-shipping]");
    if (!line) {
      line = document.createElement("div");
      line.className = "toa-cart-estimated-shipping";
      line.setAttribute("data-toa-estimated-shipping", "true");
      checkoutBlock.insertBefore(line, checkoutBlock.firstChild);
    }
    var panel = drawer.querySelector("[data-toa-cart-panel]");
    var threshold = panel ? Number(panel.getAttribute("data-threshold")) || thresholdFallback : thresholdFallback;
    var shippingBasis = cartFreeShippingBasis(cart);
    var isFree = shippingBasis >= threshold;
    line.innerHTML =
      "<span>DHL Versand voraussichtlich</span>" +
      "<strong>" + (isFree ? "0,00 &euro;" : "wird im Checkout berechnet") + "</strong>";
  }

  function enhanceRemoveButtons(drawer) {
    if (!drawer) return;
    var selectors = [
      ".cart-summary-item__remove",
      ".cart-remove-button",
      ".ajaxcart__product-remove",
      "button[name='remove']",
      "a[href*='/cart/change'][href*='quantity=0']"
    ].join(",");
    drawer.querySelectorAll(selectors).forEach(function (button) {
      if (button.closest("[data-toa-cart-panel]")) return;
      button.classList.add("toa-cart-remove-button");
      button.setAttribute("aria-label", "Produkt entfernen");
      button.setAttribute("title", "Produkt entfernen");
      if (button.getAttribute("data-toa-trash-ready") === "true") return;
      button.setAttribute("data-toa-trash-ready", "true");
      button.innerHTML = toaCartIcon("trash");
    });
  }

  function enhanceQuantityControls(drawer) {
    if (!drawer) return;
    var selectors = [
      ".cart-summary-item__quantity",
      ".qty-adjuster",
      ".quantity",
      ".ajaxcart__qty",
      "[data-quantity-wrapper]"
    ].join(",");
    drawer.querySelectorAll(selectors).forEach(function (control) {
      if (control.closest("[data-toa-cart-panel]")) return;
      control.classList.add("toa-cart-qty-pill");
    });
  }

  function ensureCheckoutTrustLine(drawer) {
    if (!drawer || drawer.querySelector("[data-toa-cart-trust-line]")) return;
    var checkout = drawer.querySelector("button[name='checkout'], input[name='checkout'], a[href*='/checkout']");
    if (!checkout) return;
    var trust = document.createElement("div");
    trust.className = "toa-cart-trust-line";
    trust.setAttribute("data-toa-cart-trust-line", "true");
    trust.innerHTML = toaCartIcon("shield") + "<span>Sichere Zahlung &amp; Datenschutz</span>";
    var anchor = getCheckoutBlock(drawer) || checkout;
    anchor.parentElement.insertBefore(trust, anchor.nextSibling);
  }

  function enhanceCartDrawer(cart) {
    var drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.add("toa-cart-drawer-upgraded");
    ensureDrawerTopbar(drawer);
    enhanceDrawerCloseControls(drawer);
    ensureDrawerBrandFallback(drawer);
    ensureProductHeading(drawer, cart);
    ensureDrawerShippingPanelPosition(drawer);
    ensureDrawerCheckoutPosition(drawer);
    enhanceRemoveButtons(drawer);
    enhanceQuantityControls(drawer);
    if (!cartIsEmpty(cart)) {
      ensureEstimatedShippingLine(drawer, cart);
      ensureCheckoutTrustLine(drawer);
    }
    setEmptyCartCheckoutState(cart);
  }

  function seedFreshFreeShippingPanels() {
    if (lastFreeShippingProgress === null || lastFreeShippingPackageLeft === null) return;
    document.querySelectorAll("[data-toa-cart-panel]:not([data-toa-free-shipping-position-ready])").forEach(function (panel) {
      panel.classList.add("is-package-seeding");
      panel.style.setProperty("--toa-free-shipping-progress", lastFreeShippingProgress + "%");
      panel.style.setProperty("--toa-free-shipping-package-left", lastFreeShippingPackageLeft + "%");
      panel.setAttribute("data-toa-free-shipping-position-ready", "seeded");
      panel.offsetHeight;
      panel.classList.remove("is-package-seeding");
    });
  }

  function updatePanels(cart) {
    if (!cart || typeof cart.total_price !== "number") return;
    cart = cartForCustomerDisplay(cart);
    updateCheckoutButtons(cart);
    enhanceCartDrawer(cart);
    var shippingBasis = cartFreeShippingBasis(cart);
    var pfandTotal = cartPfandTotal(cart);
    var panels = document.querySelectorAll("[data-toa-cart-panel]");
    panels.forEach(function (panel) {
      var threshold = Number(panel.getAttribute("data-threshold")) || thresholdFallback;
      var remaining = Math.max(0, threshold - shippingBasis);
      var progress = Math.max(0, Math.min(100, Math.round(shippingBasis / threshold * 10000) / 100));
      var progressRatio = Math.max(0, Math.min(1, shippingBasis / threshold));
      var route = panel.querySelector(".toa-cart-route");
      var routeStart = 4.5;
      var routeEnd = 75.5;
      if (route) {
        var routeStyle = window.getComputedStyle(route);
        var cssRouteStart = Number.parseFloat(routeStyle.getPropertyValue("--toa-package-route-start"));
        var cssRouteEnd = Number.parseFloat(routeStyle.getPropertyValue("--toa-package-route-end"));
        if (Number.isFinite(cssRouteStart)) routeStart = cssRouteStart;
        if (Number.isFinite(cssRouteEnd)) routeEnd = cssRouteEnd;
      }
      var packageLeft = routeStart + progressRatio * (routeEnd - routeStart);
      var message = panel.querySelector("[data-toa-free-shipping-message]");
      var submessage = panel.querySelector("[data-toa-free-shipping-submessage]");
      var goalBadge = panel.querySelector("[data-toa-free-shipping-goal-badge]");
      var previousBasis = panel.getAttribute("data-toa-last-shipping-basis");
      var previousRemaining = previousBasis === null ? null : Math.max(0, threshold - Number(previousBasis));
      var changed = previousBasis !== null && Number(previousBasis) !== shippingBasis;
      var unlocked = previousRemaining !== null && previousRemaining > 0 && remaining <= 0;
      var isFreshPanel = !panel.hasAttribute("data-toa-free-shipping-position-ready");

      if (isFreshPanel && lastFreeShippingProgress !== null && lastFreeShippingPackageLeft !== null) {
        panel.classList.add("is-package-seeding");
        panel.style.setProperty("--toa-free-shipping-progress", lastFreeShippingProgress + "%");
        panel.style.setProperty("--toa-free-shipping-package-left", lastFreeShippingPackageLeft + "%");
        panel.offsetHeight;
        panel.classList.remove("is-package-seeding");
      }

      panel.style.setProperty("--toa-free-shipping-progress", progress + "%");
      panel.style.setProperty("--toa-free-shipping-ratio", String(progressRatio));
      panel.style.setProperty("--toa-free-shipping-package-left", Math.round(packageLeft * 1000) / 1000 + "%");
      panel.classList.toggle("is-complete", remaining <= 0);
      panel.setAttribute("data-toa-last-shipping-basis", String(shippingBasis));
      panel.setAttribute("data-toa-shipping-basis", String(shippingBasis));
      panel.setAttribute("data-toa-pfand-total", String(pfandTotal));
      panel.setAttribute("data-toa-free-shipping-position-ready", "true");
      lastFreeShippingProgress = progress;
      lastFreeShippingPackageLeft = Math.round(packageLeft * 1000) / 1000;

      if (changed) {
        panel.classList.add("is-progressing");
        window.clearTimeout(panel._toaProgressTimer);
        panel._toaProgressTimer = window.setTimeout(function () {
          panel.classList.remove("is-progressing");
        }, 850);
      }
      if (unlocked) {
        panel.classList.add("is-unlocked");
        window.clearTimeout(panel._toaUnlockedTimer);
        panel._toaUnlockedTimer = window.setTimeout(function () {
          panel.classList.remove("is-unlocked");
        }, 1200);
      }

      if (message) {
        message.innerHTML = remaining > 0
          ? "Noch <span data-toa-free-shipping-remaining>" + formatMoney(remaining) + "</span> Warenwert bis kostenloser Versand"
          : "49 \u20ac Warenwert erreicht";
      }
      if (submessage) {
        if (remaining > 0) {
          if (pfandTotal > 0) {
            submessage.innerHTML = "Pfand <span class=\"toa-cart-conversion-panel__pfand-note\">nicht einberechnet</span>. Lege noch passende Produkte dazu.";
          } else {
            submessage.textContent = "Lege noch etwas dazu und spare dir die DHL Versandkosten.";
          }
        } else {
          submessage.textContent = "Deine Bestellung erreicht den DHL Gratisversand innerhalb Deutschlands.";
        }
      }
      if (goalBadge) {
        goalBadge.textContent = remaining > 0 ? "Gratis Versand" : "Gratis erreicht";
      }
    });
  }

  function fetchCartData() {
    return window.fetch("/cart.js", {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("cart");
      return response.json();
    });
  }

  function fetchCart() {
    if (!document.querySelector("[data-toa-cart-panel], .cart-summary, #cartform")) return;
    fetchCartData()
      .then(updatePanels)
      .catch(function () {});
  }

  function scheduleCartUpdate(delay) {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(fetchCart, delay || 180);
  }

  function forceCartDrawerVisible(drawer) {
    if (!drawer || !drawer.style) return;
    [
      ["display", "block"],
      ["position", "fixed"],
      ["top", "0"],
      ["left", "auto"],
      ["right", "0"],
      ["bottom", "0"],
      ["height", "100vh"],
      ["transform", "translate3d(0,0,0)"],
      ["opacity", "1"],
      ["visibility", "visible"],
      ["pointer-events", "auto"],
      ["z-index", "2147483646"]
    ].forEach(function (entry) {
      drawer.style.setProperty(entry[0], entry[1], "important");
    });
  }

  function clearForcedCartDrawerVisibility() {
    var drawer = document.querySelector(".cart-summary");
    if (!drawer || !drawer.style) return;
    [
      "display",
      "position",
      "top",
      "left",
      "right",
      "bottom",
      "height",
      "transform",
      "opacity",
      "visibility",
      "pointer-events",
      "z-index"
    ].forEach(function (property) {
      drawer.style.removeProperty(property);
    });
  }

  function openCartDrawer() {
    if (userClosedDrawer && Date.now() < cartCloseGuardUntil) return false;
    var drawer = document.querySelector(".cart-summary");
    if (!drawer) return false;
    document.documentElement.classList.remove("toa-cart-close-guard");
    document.body.classList.remove("toa-cart-close-guard");
    drawer.classList.add("active");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("show-cart-summary");
    document.body.classList.remove("show-mobile-nav");
    document.body.classList.add("show-cart-summary", "product-added-to-cart");
    forceCartDrawerVisible(drawer);
    return true;
  }

  function keepCartDrawerOpen(duration) {
    userClosedDrawer = false;
    cartCloseGuardUntil = 0;
    document.documentElement.classList.remove("toa-cart-close-guard");
    document.body.classList.remove("toa-cart-close-guard");
    keepDrawerOpenUntil = Date.now() + (duration || countdownDuration);
    openCartDrawer();
    [0, 30, 80, 160, 350, 650, 1200, 2000, 3200, 4800, 6500].forEach(function (delay) {
      window.setTimeout(function () {
        if (!userClosedDrawer && Date.now() < keepDrawerOpenUntil) openCartDrawer();
      }, delay);
    });
  }

  function allowCartDrawerClose() {
    userClosedDrawer = true;
    keepDrawerOpenUntil = 0;
    cartCloseGuardUntil = Date.now() + 1600;
    document.documentElement.classList.add("toa-cart-close-guard");
    document.body.classList.add("toa-cart-close-guard");
    document.documentElement.classList.remove("show-cart-summary");
    document.body.classList.remove("show-cart-summary", "product-added-to-cart", "updating-cart");
    var drawer = document.querySelector(".cart-summary");
    if (drawer) {
      drawer.classList.remove("active", "toa-cart-limit-flash");
      drawer.setAttribute("aria-hidden", "true");
    }
    clearForcedCartDrawerVisibility();
    [70, 180, 420, 900, 1500].forEach(function (delay) {
      window.setTimeout(function () {
        if (!userClosedDrawer || Date.now() > cartCloseGuardUntil + 80) return;
        document.documentElement.classList.add("toa-cart-close-guard");
        document.body.classList.add("toa-cart-close-guard");
        document.documentElement.classList.remove("show-cart-summary");
        document.body.classList.remove("show-cart-summary", "product-added-to-cart", "updating-cart");
        var currentDrawer = document.querySelector(".cart-summary");
        if (currentDrawer) {
          currentDrawer.classList.remove("active", "toa-cart-limit-flash");
          currentDrawer.setAttribute("aria-hidden", "true");
        }
        clearForcedCartDrawerVisibility();
      }, delay);
    });
  }

  function cssEscapeValue(value) {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(String(value));
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function findCartLineByVariant(variantId) {
    var drawer = document.querySelector(".cart-summary");
    if (!drawer || !variantId) return null;
    var byVariant = drawer.querySelector('.cart-summary-item-container[data-product-id="' + cssEscapeValue(variantId) + '"]');
    if (byVariant) return byVariant;
    var quantityControl = drawer.querySelector('.qty-adjuster[data-line-item-id="' + cssEscapeValue(variantId) + '"]');
    if (quantityControl) return quantityControl.closest(".cart-summary-item-container, .cart-summary-item");
    return null;
  }

  function scrollCartLineIntoView(line) {
    if (!line) return;
    var panel = line.closest(".cart-summary__inner");
    if (panel && panel.scrollHeight > panel.clientHeight) {
      var panelRect = panel.getBoundingClientRect();
      var lineRect = line.getBoundingClientRect();
      var target = panel.scrollTop + (lineRect.top + lineRect.height / 2) - (panelRect.top + panel.clientHeight / 2);
      try {
        panel.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
        return;
      } catch (error) {
        panel.scrollTop = Math.max(0, target);
        return;
      }
    }
    if (typeof line.scrollIntoView === "function") {
      try { line.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (error) {}
    }
  }

  function scheduleCartLineScroll(variantId) {
    [0, 160, 420, 760].forEach(function (delay) {
      window.setTimeout(function () {
        scrollCartLineIntoView(findCartLineByVariant(variantId));
      }, delay);
    });
  }

  function rememberCartHighlight(variantId) {
    if (!variantId) return;
    pendingCartHighlightVariant = String(variantId);
    pendingCartHighlightUntil = Date.now() + 6500;
  }

  function flushPendingCartHighlight() {
    if (!pendingCartHighlightVariant || Date.now() > pendingCartHighlightUntil) return false;
    var variantId = pendingCartHighlightVariant;
    var line = findCartLineByVariant(variantId);
    if (!line) return false;
    pendingCartHighlightVariant = "";
    pendingCartHighlightUntil = 0;
    pulseCartLine(variantId);
    return true;
  }

  function pulseCartLine(variantId) {
    var line = findCartLineByVariant(variantId);
    if (!line) return false;
    if (line.classList.contains("toa-cart-item-pulse")) {
      scheduleCartLineScroll(variantId);
      return true;
    }
    var oldBadge = line.querySelector(".toa-cart-confirm-badge");
    if (oldBadge) oldBadge.remove();
    var badge = document.createElement("span");
    badge.className = "toa-cart-confirm-badge";
    badge.setAttribute("aria-hidden", "true");
    badge.textContent = "Hinzugefügt";
    line.appendChild(badge);
    line.classList.add("toa-cart-item-pulse");
    scheduleCartLineScroll(variantId);
    window.setTimeout(function () {
      line.classList.remove("toa-cart-item-pulse");
      var currentBadge = line.querySelector(".toa-cart-confirm-badge");
      if (currentBadge) currentBadge.remove();
    }, 2100);
    return true;
  }

  function highlightCartItemByVariant(variantId) {
    if (!variantId) return;
    [220, 560, 980, 1450].forEach(function (delay) {
      window.setTimeout(function () {
        if (!userClosedDrawer && Date.now() < keepDrawerOpenUntil) openCartDrawer();
        pulseCartLine(variantId);
      }, delay);
    });
  }

  function showCartNotice(message) {
    injectStyle();
    var toast = document.querySelector(".toa-cart-limit-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "toa-cart-limit-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add("is-visible");
    var drawer = document.querySelector(".cart-summary");
    if (drawer) {
      drawer.classList.remove("toa-cart-limit-flash");
      void drawer.offsetWidth;
      drawer.classList.add("toa-cart-limit-flash");
      window.setTimeout(function () { drawer.classList.remove("toa-cart-limit-flash"); }, 950);
    }
    window.clearTimeout(showCartNotice.timer);
    showCartNotice.timer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 4300);
  }

  function getProductForm(node) {
    return node && node.closest && node.closest("form.product-form, form[action*='/cart/add']");
  }

  function formCanUseSmartAdd(form) {
    return !!(form && form.querySelector("[name='id']") && form.querySelector(".product-add, [name='add']"));
  }

  function selectedVariantId(form) {
    var field = form && form.querySelector("[name='id']");
    return field ? String(field.value || "").trim() : "";
  }

  function findQuantityInput(form) {
    var hidden = form.querySelector("input[type='hidden'][name='quantity']");
    var direct = form.querySelector(".qty-adjuster__value[name='quantity'], input[name='quantity']:not([type='hidden'])");
    if (direct && !direct.type.match(/hidden/i)) return direct;

    var areas = [
      form.closest(".product-detail"),
      form.closest(".product-block"),
      form.closest(".quickbuy-form"),
      form.closest(".product-form"),
      form.closest(".product-form__controls"),
      form.closest(".product-detail__form"),
      form.closest(".flex"),
      form.parentElement,
      form.parentElement && form.parentElement.parentElement
    ];
    for (var i = 0; i < areas.length; i += 1) {
      var area = areas[i];
      if (!area) continue;
      var visible = area.querySelector(".qty-adjuster__value[name='quantity'], input[name='quantity']:not([type='hidden'])");
      if (visible && !visible.closest(".cart-summary, .cart-form")) return visible;
    }

    var formRect = form.getBoundingClientRect && form.getBoundingClientRect();
    if (formRect) {
      var candidates = Array.prototype.slice.call(document.querySelectorAll(".qty-adjuster__value[name='quantity'], input[name='quantity']:not([type='hidden'])")).filter(function (input) {
        return !input.closest(".cart-summary, .cart-form");
      }).map(function (input) {
        var rect = input.getBoundingClientRect();
        return { input: input, distance: Math.abs(rect.top - formRect.top) + Math.abs(rect.left - formRect.left) };
      }).sort(function (a, b) {
        return a.distance - b.distance;
      });
      if (candidates[0] && candidates[0].distance < 700) return candidates[0].input;
    }

    return hidden || form.querySelector("input[name='quantity']");
  }

  function getWantedQuantity(form) {
    var input = findQuantityInput(form);
    var quantity = input ? parseInt(input.value, 10) : 1;
    return Math.max(1, isNaN(quantity) ? 1 : quantity);
  }

  function syncFormQuantityBeforeAdd(form, quantity) {
    var value = String(Math.max(1, Number(quantity) || 1));
    var hidden = form.querySelector("input[type='hidden'][name='quantity']");
    if (hidden) hidden.value = value;
    var direct = form.querySelector("input[name='quantity']:not([type='hidden'])");
    if (direct && direct !== document.activeElement) direct.value = value;
  }

  function getStockLimit(form) {
    var input = findQuantityInput(form);
    var adjuster = input && input.closest(".qty-adjuster");
    var area = form.closest(".product-detail, .product-block, .quickbuy-form, .product-form, .flex") || form.parentElement;
    var fromAdjuster = adjuster && adjuster.getAttribute("data-limit");
    var fromArea = area && area.querySelector(".qty-adjuster[data-limit]") && area.querySelector(".qty-adjuster[data-limit]").getAttribute("data-limit");
    var limit = parseInt(fromAdjuster || fromArea || "", 10);
    return isNaN(limit) ? 0 : limit;
  }

  function getFormForQuantityInput(input) {
    var form = getProductForm(input);
    if (form) return form;
    var area = input && (input.closest(".product-detail, .product-block, .quickbuy-form, .flex, .product-form") || input.parentElement);
    return area && area.querySelector("form.product-form, form[action*='/cart/add']");
  }

  function scheduleStorefrontQuantitySync(input, delay) {
    if (!isStorefrontQuantityInput(input)) return;
    window.clearTimeout(storefrontQuantitySyncTimer);
    storefrontQuantitySyncTimer = window.setTimeout(function () {
      syncStorefrontQuantityToCart(input);
    }, delay || 160);
  }

  function syncStorefrontQuantityToCart(input) {
    var form = getFormForQuantityInput(input);
    if (!form || !formCanUseSmartAdd(form)) return;
    var variantId = selectedVariantId(form);
    if (!variantId) return;

    var desiredQuantity = parseInt(input.value, 10);
    if (isNaN(desiredQuantity) || desiredQuantity < 1) desiredQuantity = 1;

    var limit = getStockLimit(form);
    if (limit > 0 && desiredQuantity > limit) {
      desiredQuantity = limit;
      input.value = String(limit);
      showCartNotice("Nur " + limit + " Stück verfügbar.");
    }

    enqueueCartMutation(function () {
      return fetchCartData().then(function (cart) {
      var currentItem = (cart.items || []).find(function (item) {
        return String(item.id) === String(variantId);
      });
      var currentQuantity = currentItem ? Number(currentItem.quantity) || 0 : 0;
      if (currentQuantity <= 0 || desiredQuantity === currentQuantity) return null;
      return postCart("/cart/change.js", { id: variantId, quantity: desiredQuantity });
      });
    }).then(function (result) {
      normaliseProductAddButtons(document);
      if (!result) return;
      keepCartDrawerOpen();
      refreshThemeCart(true);
      highlightCartItemByVariant(variantId);
      showCartNotice("Menge im Warenkorb auf " + desiredQuantity + " aktualisiert.");
    }).catch(function () {
      showCartNotice("Die Warenkorbmenge konnte gerade nicht aktualisiert werden.");
      keepCartDrawerOpen();
    });
  }

  function setFormLoading(form, loading) {
    var buttons = form.querySelectorAll(".product-add, [name='add']");
    buttons.forEach(function (button) {
      button.classList.toggle("product-add--adding", !!loading);
      if (loading) {
        button.setAttribute("disabled", "disabled");
      } else {
        button.removeAttribute("disabled");
      }
    });
  }

  function resetProductQuantity(form, quantity) {
    var value = String(Math.max(1, Number(quantity) || 1));
    var input = findQuantityInput(form);
    if (input) input.value = value;
    var hidden = form.querySelector("input[type='hidden'][name='quantity']");
    if (hidden) hidden.value = value;
  }

  function normaliseProductAddButtons(root) {
    var scope = root || document;
    scope.querySelectorAll("form.product-form, form[action*='/cart/add']").forEach(function (form) {
      if (!formCanUseSmartAdd(form) || form.closest(".cart-summary")) return;
      form.classList.remove("product-form--added", "product-form--temp-could-remove");
      form.querySelectorAll(".product-add").forEach(function (button) {
        if (button.getAttribute("data-btn-type") === "in-cart") button.setAttribute("data-btn-type", "add-to-cart");
        var text = button.querySelector(".button-text");
        if (text && /Aus dem Warenkorb|Remove/i.test(text.textContent || "")) {
          text.textContent = "In den Warenkorb";
        }
      });
    });
  }

  function postCart(endpoint, payload) {
    return window.fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          var error = new Error(json && (json.description || json.message) || "cart error");
          error.payload = json;
          throw error;
        }
        return json;
      });
    });
  }

  function enqueueCartMutation(task) {
    cartMutationQueue = cartMutationQueue.catch(function () {}).then(function () {
      document.documentElement.classList.add("toa-cart-mutating");
      return task();
    }).finally(function () {
      document.documentElement.classList.remove("toa-cart-mutating");
    });
    return cartMutationQueue;
  }

  function refreshThemeCart(openDrawer) {
    renderCountdown();
    if (window.theme && typeof window.theme.updateCartSummaries === "function") {
      window.theme.updateCartSummaries(!!openDrawer, true, false);
    }
    if (openDrawer) keepCartDrawerOpen();
    scheduleCartUpdate(120);
    window.setTimeout(function () {
      normaliseProductAddButtons(document);
      if (openDrawer) keepCartDrawerOpen();
      flushPendingCartHighlight();
    }, 450);
    window.setTimeout(function () {
      normaliseProductAddButtons(document);
      if (openDrawer) keepCartDrawerOpen();
      scheduleCartUpdate(60);
      flushPendingCartHighlight();
    }, 1200);
    window.setTimeout(function () {
      normaliseProductAddButtons(document);
      if (openDrawer) keepCartDrawerOpen();
      scheduleCartUpdate(60);
      flushPendingCartHighlight();
    }, 2400);
  }

  function smartAddToCart(form, sourceEvent) {
    if (!formCanUseSmartAdd(form)) return false;
    var variantId = selectedVariantId(form);
    if (!variantId) return false;
    rememberCartHighlight(variantId);
    if (sourceEvent) {
      sourceEvent.preventDefault();
      sourceEvent.stopImmediatePropagation();
      sourceEvent.stopPropagation();
    }
    restartCountdown();
    keepCartDrawerOpen();
    var wantedQuantity = getWantedQuantity(form);
    syncFormQuantityBeforeAdd(form, wantedQuantity);
    var limit = getStockLimit(form);
    var cappedApplied = false;
    var alreadyMaxNoticeShown = false;
    var appliedQuantity = wantedQuantity;
    setFormLoading(form, true);

    enqueueCartMutation(function () {
      return fetchCartData().then(function (cart) {
        var currentItem = (cart.items || []).find(function (item) {
          return String(item.id) === String(variantId);
        });
        var currentQuantity = currentItem ? Number(currentItem.quantity) || 0 : 0;
        var finalQuantity = currentQuantity > 0
          ? (wantedQuantity === currentQuantity ? currentQuantity + 1 : wantedQuantity)
          : wantedQuantity;
        var capped = false;

        if (limit > 0 && finalQuantity > limit) {
          finalQuantity = limit;
          capped = true;
          cappedApplied = true;
        }

        if (limit > 0 && finalQuantity <= currentQuantity && wantedQuantity >= currentQuantity) {
          showCartNotice("Nur " + limit + " Stück verfügbar. Diese Menge liegt bereits im Warenkorb.");
          alreadyMaxNoticeShown = true;
          keepCartDrawerOpen();
          refreshThemeCart(true);
          return null;
        }

        appliedQuantity = finalQuantity;
        if (currentQuantity > 0) {
          return postCart("/cart/change.js", { id: variantId, quantity: finalQuantity });
        }
        return postCart("/cart/add.js", { id: Number(variantId) || variantId, quantity: finalQuantity });
      });
    }).then(function (result) {
      resetProductQuantity(form, appliedQuantity);
      normaliseProductAddButtons(document);
      keepCartDrawerOpen();
      refreshThemeCart(true);
      if (result) highlightCartItemByVariant(variantId);
      if (cappedApplied && !alreadyMaxNoticeShown) {
        showCartNotice("Nur " + limit + " Stück verfügbar. Ich habe die maximal mögliche Menge übernommen.");
      }
    }).catch(function (error) {
      var message = error && error.message ? error.message : "Der Warenkorb konnte gerade nicht aktualisiert werden.";
      showCartNotice(message);
      keepCartDrawerOpen();
    }).finally(function () {
      setFormLoading(form, false);
      window.setTimeout(function () { normaliseProductAddButtons(document); }, 100);
    });
    return true;
  }

  function isStorefrontQuantityInput(input) {
    if (!input || !input.matches || !input.matches(".qty-adjuster__value[name='quantity']")) return false;
    if (input.closest(".cart-summary, .cart-form")) return false;
    var area = input.closest(".product-detail, .product-block, .quickbuy-form, .flex, .product-form") || input.parentElement;
    return !!(area && area.querySelector("form.product-form, form[action*='/cart/add']"));
  }

  document.addEventListener("DOMContentLoaded", function () {
    injectStyle();
    normaliseProductAddButtons(document);
    renderCountdown();
    scheduleCartUpdate(60);
  });

  window.addEventListener("pageshow", function () {
    injectStyle();
    normaliseProductAddButtons(document);
    renderCountdown();
    scheduleCartUpdate(60);
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (formCanUseSmartAdd(form)) {
      rememberCartHighlight(selectedVariantId(form));
      smartAddToCart(form, event);
    }
  }, true);

  ["pointerdown", "touchstart", "mousedown"].forEach(function (type) {
    document.addEventListener(type, function (event) {
      closeDrawerIfControlEvent(event);
    }, { capture: true, passive: false });
  });

  document.addEventListener("click", function (event) {
    if (closeDrawerIfControlEvent(event)) return;
    var overlayTarget = event.target.closest("#page-overlay, .page-overlay");
    if (overlayTarget) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      allowCartDrawerClose();
      return;
    }
    var closeTarget = event.target.closest(".cart-summary__close, .cart-close, .drawer__close, .js-close-cart, [data-cart-close]");
    if (closeTarget) {
      allowCartDrawerClose();
      return;
    }
    var directAddButton = event.target.closest(".product-add, [name='add']");
    if (directAddButton) {
      var directAddForm = getProductForm(directAddButton);
      if (formCanUseSmartAdd(directAddForm)) {
        rememberCartHighlight(selectedVariantId(directAddForm));
        smartAddToCart(directAddForm, event);
        return;
      }
    }
    var inCartButton = event.target.closest(".btn[data-btn-type='in-cart'], .product-add[data-btn-type='in-cart']");
    if (inCartButton) {
      var inCartForm = getProductForm(inCartButton);
      rememberCartHighlight(selectedVariantId(inCartForm));
      smartAddToCart(inCartForm, event);
      return;
    }
    var toggle = event.target.closest(".toggle-cart-summary");
    if (toggle && !toggle.closest(".cart-summary")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      keepCartDrawerOpen();
      refreshThemeCart(true);
      return;
    }
    if ((document.body.classList.contains("show-cart-summary") || document.documentElement.classList.contains("show-cart-summary")) && !event.target.closest(".cart-summary")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      allowCartDrawerClose();
      return;
    }
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.key === "Esc") {
      allowCartDrawerClose();
    }
  }, true);

  document.addEventListener("change", function (event) {
    if (isStorefrontQuantityInput(event.target)) {
      event.stopImmediatePropagation();
      scheduleStorefrontQuantitySync(event.target, 120);
      normaliseProductAddButtons(document);
    }
  }, true);

  document.addEventListener("click", function (event) {
    var storefrontStep = event.target.closest(".qty-adjuster__up, .qty-adjuster__down");
    if (storefrontStep) {
      var storefrontAdjuster = storefrontStep.closest(".qty-adjuster");
      var storefrontInput = storefrontAdjuster && storefrontAdjuster.querySelector(".qty-adjuster__value[name='quantity']");
      if (isStorefrontQuantityInput(storefrontInput)) {
        window.setTimeout(function () {
          scheduleStorefrontQuantitySync(storefrontInput, 80);
        }, 70);
      }
    }
    if (event.target.closest(".qty-adjuster__up, .qty-adjuster__down, .qty-adjuster__remove, .product-add, [name='add']")) {
      var isRemove = event.target.closest(".qty-adjuster__remove, .toa-cart-remove-button, .cart-summary-item__remove, .cart-remove-button, a[href*='quantity=0']");
      scheduleCartUpdate(isRemove ? 80 : 650);
      window.setTimeout(scheduleCartUpdate, isRemove ? 420 : 1200);
      if (isRemove) window.setTimeout(scheduleCartUpdate, 950);
    }
  }, true);

  document.addEventListener("change", function (event) {
    if (event.target.matches(".qty-adjuster__value, input[name^='updates']")) {
      scheduleCartUpdate(650);
    }
  }, true);

  if (window.jQuery) {
    window.jQuery(window).on("cc-cart-updated.toaCartEnhancements", function () {
      renderCountdown();
      normaliseProductAddButtons(document);
      if (!userClosedDrawer && Date.now() < keepDrawerOpenUntil) {
        window.setTimeout(openCartDrawer, 30);
        window.setTimeout(openCartDrawer, 180);
        window.setTimeout(openCartDrawer, 420);
      }
      window.setTimeout(flushPendingCartHighlight, 90);
      window.setTimeout(flushPendingCartHighlight, 360);
      window.setTimeout(flushPendingCartHighlight, 820);
      scheduleCartUpdate(60);
    });
    window.jQuery(document).ajaxComplete(function (_event, _xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : "";
      if (url.indexOf("/cart") !== -1 || url.indexOf("sections=cart") !== -1) {
        renderCountdown();
        scheduleCartUpdate(80);
        window.setTimeout(flushPendingCartHighlight, 120);
        window.setTimeout(flushPendingCartHighlight, 520);
      }
    });
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            node.matches && node.matches("[data-toa-cart-panel], .cart-summary") ||
            node.querySelector && node.querySelector("[data-toa-cart-panel], .cart-summary")
          );
        });
      });
      if (!relevant) return;
      seedFreshFreeShippingPanels();
      window.clearTimeout(mutationTimer);
      mutationTimer = window.setTimeout(function () {
        injectStyle();
        normaliseProductAddButtons(document);
        if (!userClosedDrawer && Date.now() < keepDrawerOpenUntil) keepCartDrawerOpen();
        renderCountdown();
        scheduleCartUpdate(70);
        flushPendingCartHighlight();
      }, 70);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  injectStyle();
  normaliseProductAddButtons(document);
  renderCountdown();
  window.setInterval(renderCountdown, 1000);
  window.setInterval(function () {
    if (!userClosedDrawer && Date.now() < keepDrawerOpenUntil) {
      openCartDrawer();
    }
  }, 900);
  scheduleCartUpdate(120);
})();
